// src/redux/reducers/cityReducer.js
import {
    FETCH_GETORGDCOMP_FAILURE,
    FETCH_GETORGDCOMP_REQUEST,
    FETCH_GETORGDCOMP_SUCCESS, 
    SET_SELECTED_GETORGDCOMP ,
  } from '../types'; 
  
  const initialState = {
    loading: false,
    getRegdCompList: [],
    selectedgetallId: null, 
    error: null,
  };
  
  
  const getRegdCompReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GETORGDCOMP_REQUEST:
        return { ...state, loading: true };
      case FETCH_GETORGDCOMP_SUCCESS:
        return { ...state, loading: false, getRegdCompList: action.payload };
      case FETCH_GETORGDCOMP_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_GETORGDCOMP:
        return { ...state, selectedgetallId: action.payload };
      default:
        return state;
    }
  };
  
  export default getRegdCompReducer;



  